export default __webpack_public_path__ + "static/media/illustration_results.d7916fe4.png";